import React from "react";

import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";

import { DefaultTooltip } from "../../../../../../components/Generic/Tooltip";
import { LinkContainer, LinkIcon } from "./styles";

interface Props {
  openBookingModal: (id?: number) => void;
  bookingReference?: string;
  bookingId?: number;
}

const SharedBooking = (props: Props) => {
  const { bookingId, bookingReference, openBookingModal } = props;
  const { t: translate } = useTranslation();

  const openModal = () => {
    if (bookingId) openBookingModal(bookingId);
  };

  if (!bookingReference) return null;

  return (
    <Box display={"flex"} flexDirection={"row"} justifyContent={"flex-start"} alignItems={"center"}>
      <span>{bookingReference}</span>
      {bookingId && (
        <DefaultTooltip title={translate("viewBooking")} placement="right">
          <LinkContainer>
            <LinkIcon size={15} onClick={() => openModal()} />
          </LinkContainer>
        </DefaultTooltip>
      )}
    </Box>
  );
};

export default SharedBooking;
